module.exports = __webpack_public_path__ + "static/media/panel_wing_right.2e334d5d.png";